import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { useMediaQuery, Grid, colors } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import IconAlternate from '../../../shared/IconAlternate'
import DescriptionListIcon from '../../../shared/DescriptionListIcon'
import uid from '../../../shared/uid'
const useStyles = makeStyles((theme) => ({
  root: {},
  landingPageServices: {
    '& .icon-alternate': {
      background: '#7C45EF',
      borderRadius: '100%',
      '& i': {
        color: '#fff !important',
      },
    },
    '& h6': {
      fontSize: 24,
      fontWeight: 800,
      color: theme.palette.common.black,
      [theme.breakpoints.down('1450')]: {
        fontSize: 21,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 22,
      },
    },
    '& .description-list-icon__subtitle-wrapper': {
      paddingTop: 0,
      '& p': {
        fontSize: 20,
        fontWeight: 400,
        color: theme.palette.common.black,
        [theme.breakpoints.down('1450')]: {
          fontSize: 16,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 18,
        },
      },
    },
  },
  commanTitle: {
    textAlign: 'center',
    marginBottom: 50,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 0,
    },
    '& h4': {
      fontWeight: 800,
      fontSize: 50,
      lineHeight: '60px',
      color: '#1A1A1A',
      marginBottom: 30,
      [theme.breakpoints.down('xs')]: {
        fontSize: 36,
        lineHeight: '43px',
        marginBottom: 16,
      },
    },
    '& p': {
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '24px',
      color: theme.palette.common.black,
      [theme.breakpoints.down('xs')]: {
        fontSize: 18,
        lineHeight: '22px',
      },
    },
  },
  serviceBoxContainer: {
    marginTop: 50,
  },
  serviceBox: {
    '&.MuiGrid-item': {
      margin: '0 0 13px',
      [theme.breakpoints.down('xs')]: {
        margin: '0 0 25px',
      },
    },
  },
}))

const Services = (props) => {
  const { data } = props
  const classes = useStyles()

  const theme = useTheme()
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      {/* <div className={clsx(classes.root, className)} {...rest}> */}
      <Grid container justifyContent="center">
        <Grid item sm={8} md={5}>
          <div className={classes.commanTitle}>
            <Typography variant="h4">Save time and money</Typography>
            <Typography variant="body1">
              Conduiit saves you time and money by connecting fragmented
              processes and eliminating friction.
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        className={classes.serviceBoxContainer}
        spacing={isMd ? 4 : 2}
      >
        {data.map((item) => (
          <Grid
            key={uid()}
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.serviceBox}
            data-aos="fade-up"
          >
            <DescriptionListIcon
              title={item.title}
              subtitle={item.subtitle}
              className={classes.landingPageServices}
              icon={
                <IconAlternate
                  fontIconClass={item.icon}
                  size="medium"
                  color={colors.indigo}
                />
              }
              align="left"
            />
          </Grid>
        ))}
      </Grid>
      {/* </div> */}
    </>
  )
}

Services.propTypes = {
  // className: PropTypes.string,
  data: PropTypes.array.isRequired,
}

export default Services
